

import React, { memo } from 'react';
import cx from 'classnames';
import { Image } from '../../Image';
import onEnterPressed from '../../../common/utils/onEnterPressed';
import { IMAGE_CARD, IMAGE_CARD_EMPTY, IMAGE_CARD_CHILD } from '../styles/imageCard';










function ImageCard({
  imageUrl,
  width,
  height,
  title,
  subtitle,
  onClick
}) {
  return (
    <div
      className={cx('image-card', IMAGE_CARD(width, height))}
      tabIndex={0}
      role="button"
      onClick={onClick}
      onKeyDown={onEnterPressed({ onClick })}>

      {imageUrl ?
      <Image width="100%" height="100%" imageUrl={imageUrl} backgroundSize="cover" /> :

      <div className={cx('image-card-empty', IMAGE_CARD_EMPTY)} />}

      <div className={cx('image-card__child', IMAGE_CARD_CHILD)}>
        {title && <p className="title">{title}</p>}
        {subtitle && <p className="sub-title">{subtitle}</p>}
      </div>
    </div>);

}

ImageCard.defaultProps = {
  width: '300px',
  height: '150px',
  imageUrl: void 0,
  title: void 0,
  subtitle: void 0
};

export default memo(ImageCard);